import React, { useState } from "react";
import {
  Tabel,
  DropDown,
  Grid,
  DropDownMenu,
  Section,
  BreadCrumbBox,
  Typography,
  Select,
  Loading,
} from "../../core";
import { Link } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { Menu } from "antd";
import { useSizerData } from "../../hooks/useSizerData";
import { getProgramsBySizer } from "../../helper/utils/api/sizer";
import { getCompanyId } from "../../helper/utils/companyId";

const CHANGE_DATE_FORMAT = require("../../helper/utils/datFormat");

const GenrateBill = () => {
  useSizerData();
  const sizerList = useSelector((state) => state.sizer.sizer) || [];
  const [selectedSizerId, setSelectedSizerId] = useState(null);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadPrograms = async (sizerId) => {
    const companyId = getCompanyId();
    if (!sizerId || !companyId) {
      setRows([]);
      return;
    }
    setIsLoading(true);
    try {
      const { data } = await getProgramsBySizer(sizerId, companyId);
      setRows(
        (Array.isArray(data) ? data : []).map((r, i) => ({
          ...r,
          key: r._id || i,
          sr: i + 1,
        }))
      );
    } catch (error) {
      console.log("programs load error", error);
      setRows([]);
    }
    setIsLoading(false);
  };

  const onchange = (value) => {
    setSelectedSizerId(value);
    loadPrograms(value);
  };

  const columns = [
    { title: "Sr #", dataIndex: "sr", key: "sr", width: 80 },
    { title: "Quality", dataIndex: "quality", key: "quality", width: 150 },
    { title: "Quantity", dataIndex: "quanity", key: "quanity", width: 150 },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (text, record) =>
        CHANGE_DATE_FORMAT.changeDateFormat(record.date),
      width: 150,
    },
    { title: "Amount", dataIndex: "ammount", key: "ammount", width: 150 },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 150,
      render: (text, record) => (
        <DropDown
          overlay={
            <MenuCompo record={record} sizerId={selectedSizerId} />
          }
        />
      ),
    },
  ];

  return (
    <Grid>
      {isLoading ? <Loading /> : null}
      <Section>
        <BreadCrumbBox tittle="Pay Now" route="/sizer-dashboard" />
      </Section>
      <Section className="mt-10" padding="20px">
        <Typography weight="800" align="center" color="#3D5166">
          Search Sizer
        </Typography>
        <div>
          <Select
            onChange={onchange}
            className="d-block m-auto"
            width="250px"
            prefixIcon={<UserOutlined />}
            placeholder="Sizer name"
            type="sizerList"
            Options={sizerList}
          />
        </div>
        <Tabel
          defaultPageSize={10}
          nowidth={false}
          columns={columns}
          data={rows}
          className="mt-20"
          rowKey="key"
        />
      </Section>
    </Grid>
  );
};

const MenuCompo = ({ record, sizerId }) => (
  <DropDownMenu>
    <Menu.Item key="invoice-generate">
      <Link
        to={{
          pathname: `/generate-bill/${record._id || record.add_program_id}`,
          state: { program: record, sizerId },
        }}
      >
        Generate Bill
      </Link>
    </Menu.Item>
  </DropDownMenu>
);

export default GenrateBill;
